export default __webpack_public_path__ + "static/media/Other Home Items.d9cbfdbc.png";